(() => {
  'use strict';
  let busy = false;
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-gb-cart-add] select');
    if (!select) return;
    const card = select.closest('.product-upsell__holder');
    const option = select.selectedOptions[0];
    card.querySelectorAll('.gb-cart-value').forEach(node => node.remove());
    if (option?.dataset.price) card.querySelector('.product-upsell__price').textContent = option.dataset.price;
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-gb-cart-add]');
    if (!form) return;
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    busy = true;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-gb-add-status]');
    const select = form.querySelector('select');
    const variant = select.value;
    if (!/^\d+$/.test(variant) || select.selectedOptions[0]?.disabled) { busy = false; return; }
    button.disabled = true;
    button.textContent = 'Adding…';
    status.textContent = '';
    try {
      const response = await fetch(form.action + '.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:variant,quantity:1}]})});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'This option could not be added. Check availability and try again.');
      status.textContent = 'Added. Updating your cart…';
      // The native theme updates lines, discounts, totals and the cart count.
      await new Promise(resolve => {
      const done = () => {
        clearTimeout(timer);
        document.removeEventListener('theme:product:added', done);
        const live = document.getElementById('gb-cart-add-confirmation') || document.body.appendChild(Object.assign(document.createElement('p'),{id:'gb-cart-add-confirmation',className:'gb-cart-add-confirmation'}));
        live.setAttribute('role','status'); live.textContent = 'Added to cart. Your total has been updated.';
        resolve();
      };
      const timer = setTimeout(() => {
        document.removeEventListener('theme:product:added', done);
        status.textContent = 'Added. Refresh the cart to see the updated total.';
        resolve();
      }, 8000);
      document.addEventListener('theme:product:added', done, {once:true});
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles:true}));
      });
    } catch (error) {
      status.textContent = error instanceof TypeError ? 'Connection interrupted. Check your cart before trying again.' : error.message;
    } finally {
      busy = false;
      button.disabled = false;
      button.textContent = 'Add to cart';
    }
  });
})();
